module.exports = __webpack_public_path__ + "static/media/diagnoses_unselected.ce71212c.svg";